import { Button, Checkbox, Menu, Stack } from '@mantine/core';
import { BiSortAlt2 } from 'react-icons/bi';

export interface SortOption {
  field: string;
  order: SortOrder.ASC | SortOrder.DESC;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortField {
  PAY_RATE = 'payRate',
  DATE_PUBLISHED = 'datePublished',
}
interface SortDropdownProps {
  selectedSort: SortOption | null;
  onSortChange: (field: string, order: SortOrder.ASC | SortOrder.DESC) => void;
  onApply: () => void;
}

export interface ISortOption {
  label: string;
  field: SortField;
  order: SortOrder;
}

const SORT_OPTIONS: ISortOption[] = [
  { label: 'Highest Paid', field: SortField.PAY_RATE, order: SortOrder.DESC },
  { label: 'Lowest Paid', field: SortField.PAY_RATE, order: SortOrder.ASC },
  {
    label: 'Newest Posted',
    field: SortField.DATE_PUBLISHED,
    order: SortOrder.DESC,
  },
] as const;

export default function SortDropdown({
  selectedSort,
  onSortChange,
  onApply,
}: SortDropdownProps) {
  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <Button variant="light" w={40} fw={700} p={5}>
          <BiSortAlt2 data-testid="sort-icon" size={20} />
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Stack gap="xs" p={10}>
          {SORT_OPTIONS.map((option) => (
            <Checkbox
              key={option.field}
              label={option.label}
              checked={
                selectedSort?.field === option.field &&
                selectedSort?.order === option.order
              }
              onChange={(event) => {
                if (event.currentTarget.checked) {
                  onSortChange(option.field, option.order);
                }
              }}
              classNames={{
                label: 'cursor-pointer m-0',
                root: 'py-1 px-2',
              }}
            />
          ))}
          <Button
            variant="filled"
            fullWidth
            onClick={onApply}
            disabled={!selectedSort}
            className="py-2 px-4 mt-1"
          >
            Apply
          </Button>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
}
